/**
 * @fileoverview i18next — TR senkron; EN/RU ayrı chunk (Lighthouse kullanılmayan JS).
 */
import i18n, { i18nInitPromise } from './core.js'
import { readPersistedLanguage } from './readPersistedLanguage.js'
import { ensureLocalesLoaded, scheduleWarmupLocales } from './ensureLocalesLoaded.js'

export default i18n
export { i18nInitPromise }

/** main.jsx ilk açılış: kalıcı dil + en/ru chunk’ları; boşta diğer dil ısıtması */
export async function initI18nBootstrap() {
  await i18nInitPromise
  const lng = readPersistedLanguage()
  await ensureLocalesLoaded(lng)
  await i18n.changeLanguage(lng)
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng
  }
  scheduleWarmupLocales(lng)
}
